
import defaultNuevaCuentaForm from "@/util/rrhh/defaultNuevaCuentaForm.js"
import defaultCredentialsForm from "@/util/rrhh/defaultCredentialsForm.js"
import defaultCommunicateForm from "@/util/rrhh/defaultCommunicateForm.js"

import axios from "axios"
import qs from "qs"
import { clone, objectCamelToSnakeCase, objectSnakeToCamelCase, deleteKeyNullValues, removeEmpty } from "@/util/libUtil.js"

const state = {
    nuevaCuentaDialogo: {
        isOpen: false,
        isSaving: false,
        form: clone(defaultNuevaCuentaForm)
    },
    editarCuentaDialogo: {
        isOpen: false,
        isSaving: false,
        form: clone(defaultNuevaCuentaForm),
    },
    viewCuentaDialogo: {
        isOpen: false,
        form: clone(defaultNuevaCuentaForm)
    },
    cuentasTable: {
        cuentas: [], //Contiene una lista con las cuentas que se ven en la tabla.
        totalEntries: 0,
        isLoading: false,
        page: 1,
        params: {}
    },
    communicates: {
        form: clone(defaultCommunicateForm),
        type: 'CREATE',
        isLoading: false,
        isOpenCommunicateView: false,
        isOpen: false,
        communicates: []
    },
    credentials: {
        form: clone(defaultCredentialsForm),
        type: 'CREATE',
        isLoading: false,
        isOpenCredentialsView: false,
        isOpen: false,
        credentials: []
    },
    clicksToTenant: 0,
    paths: {
        cuentasPath: '/api/cuentas/entradas/',
        distribuidorPath: '/api/distribuidores/distribuidor/',
        credentialsPath: '/api/scraping/claves/',
        communicatesPath: '/api/cuentas/communicates/',
        setReadCommunicatePath: '/api/cuentas/set-read-communicate/',
        userImageUploadPath: '/api/storage/user-images/',
    }
}

const mutations = {
    setDefaultFormNuevaCuenta(state) {
        state.nuevaCuentaDialogo.form = clone(defaultNuevaCuentaForm)
    },
    communicates(state, val) {
        state.communicates.communicates = clone(val)
    },
    communicatesLoading(state, val) {
        state.communicates.isLoading = val
    },
    communicatesForm(state, val) {
        state.communicates.form = clone(val)
    },
    communicatesType(state, val) {
        state.communicates.type = val
    },
    isOpenCommunicateView(state, val) {
        state.communicates.isOpenCommunicateView = val
    },
    isOpenCommunicatesSummary(state, val) {
        state.communicates.isOpen = val
    },
    credentials(state, val) {
        state.credentials.credentials = clone(val)
    },
    credentialsLoading(state, val) {
        state.credentials.isLoading = val
    },
    credentialsForm(state, val) {
        state.credentials.form = clone(val)
    },
    credentialsType(state, val) {
        state.credentials.type = val
    },
    isOpenCredentialsView(state, val) {
        state.credentials.isOpenCredentialsView = val
    },
    isOpenCredentialsSummary(state, val) {
        state.credentials.isOpen = val
    },
    clicksToTenant(state, val) {
        state.clicksToTenant = val
    },
    isOpenNuevaCuentaDialogo(state, val) {
        state.nuevaCuentaDialogo.isOpen = val
    },
    openNewTenantDialog(state, val) {
        state.newTenant.isOpen = val
    },
    cuentas(state, val) {
        state.cuentasTable.cuentas = clone(val)
    },
    cuentasTable(state, val) { // mutation para las cuentas visibles en la tabla
        state.cuentasTable.totalEntries = val.count
        state.cuentasTable.cuentas = val.results
    },
    cuentasTablePage(state, val) {
        state.cuentasTable.page = val
    },
    cuentasTableParams(state, val) {
        state.cuentasTable.params = val
    },
    cuentasTableIsLoading(state, val) {
        state.cuentasTable.isLoading = val
    },
    nuevaCuentaDialogoIsSaving(state, val) {
        state.nuevaCuentaDialogo.isSaving = val
    },
    editarCuentaDialogoIsSaving(state, val) {
        state.editarCuentaDialogo.isSaving = val
    },
    editarCuentaDialogo(state, { isOpen, isSaving, form }) {
        state.editarCuentaDialogo.form = form
        state.editarCuentaDialogo.isOpen = isOpen
        state.editarCuentaDialogo.isSaving = isSaving
    },
    openCuentaDialogo(state, { isOpen, form }) {
        state.viewCuentaDialogo.form = form
        state.viewCuentaDialogo.isOpen = isOpen
    },
}

const actions = {
    async setReadCommunicate({ state, commit, getters }, { id }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.setReadCommunicatePath), { id })
        } catch (error) {
            console.log(error)
        }
    },
    async fetchCommunicates({ state, commit, getters }, params) {
        if (!state.communicates.isLoading){
            try {
                commit('communicatesLoading', true)
                const res = await axios.get(getters.getEndpointFromPath(state.paths.communicatesPath), { params })
    
                if ('receivers' in params)
                    localStorage.setItem('communicates', JSON.stringify(objectSnakeToCamelCase(res.data)))
                else
                    commit('communicates', clone(objectSnakeToCamelCase(res.data)))
    
            } catch (error) {
                console.log(error)
            }
            commit('communicatesLoading', false)
        }
    },
    async deleteCommunicates({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.communicatesPath)}${id}/`)
            dispatch('fetchCommunicates', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Comunicado Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Comunicado',
            }, { root: true })
        }
    },
    async createCommunicates({ getters, state, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.communicatesPath), state.communicates.form)
            dispatch('fetchCommunicates', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },
    async fetchCredentials({ state, commit, getters }) {
        try {
            const res = await axios.get(getters.getEndpointFromPath(state.paths.credentialsPath))
            commit('credentials', res.data)

        } catch (error) {
            console.log(error)
        }
    },
    async deleteCredentials({ state, getters, dispatch, commit }, id) {
        try {
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.credentialsPath)}${id}/`)
            dispatch('fetchCredentials', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Credenciales',
            }, { root: true })
        }
    },
    async createCredentials({ getters, state, dispatch, commit }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.credentialsPath), state.credentials.form)
            dispatch('fetchCredentials', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },
    async updateCredentials({ getters, state, dispatch, commit }) {
        try {
            await axios.put(`${getters.getEndpointFromPath(state.paths.credentialsPath)}${state.credentials.form.id}/`, deleteKeyNullValues(state.credentials.form))
            dispatch('fetchCredentials', {})
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Credenciales Creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Credenciales',
            }, { root: true })
        }
    },
    closeNuevaCuentaDialogo({ commit }) {
        commit('isOpenNuevaCuentaDialogo', false)
        commit('setDefaultFormNuevaCuenta')
    },
    openNuevaCuentaDialogo({ commit }) {
        commit('isOpenNuevaCuentaDialogo', true)
    },
    openCuentaDialogo({ commit }, cuenta) {
        commit('openCuentaDialogo', {
            isOpen: true,
            form: clone(cuenta)
        })
    },
    closeCuentaDialogo({ commit }) {
        commit('openCuentaDialogo', {
            isOpen: false,
            form: clone(defaultNuevaCuentaForm)
        })
    },
    openEditarCuentaDialogo({ commit }, cuenta) {
        commit('editarCuentaDialogo', {
            isOpen: true,
            isSaving: false,
            form: clone(cuenta)
        })
    },
    closeEditarCuentaDialogo({ commit }) {
        commit('editarCuentaDialogo', {
            isOpen: false,
            isSaving: false,
            form: clone(defaultNuevaCuentaForm)
        })
    },
    async getCuentasTableData({ state, commit, getters }, numPerPage = null) {
        return new Promise((resolve, reject) => {
            commit('cuentasTableIsLoading', true)

            let params = clone(state.cuentasTable.params)
            if (numPerPage)
                params['itemsPerPage'] = numPerPage

            axios.get(getters.getEndpointFromPath(state.paths.cuentasPath), {
                params: params,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                },
            })
                .then(response => {
                    // console.log(response)
                    if (!numPerPage)
                        commit('cuentasTable', objectSnakeToCamelCase(response.data))
                    // console.log(state.accountsTable.accounts)
                    commit('cuentasTableIsLoading', false)
                    resolve(objectSnakeToCamelCase(response.data))
                })
                .catch(err => {
                    commit('cuentasTableIsLoading', false)
                    reject(err)
                    throw err
                })
        })
    },
    async crearCuenta({ getters, state, dispatch, commit }) {
        return new Promise((resolve, reject) => {
            commit('nuevaCuentaDialogoIsSaving', true)
            // Get from form tipoComercial
            axios.post(getters.getEndpointFromPath(state.paths.cuentasPath),
                objectCamelToSnakeCase(deleteKeyNullValues(state.nuevaCuentaDialogo.form)))
                .then((response) => {
                    dispatch('util/showStatusSnackBar', {
                        statusType: "success",
                        message: "Cuenta guardada correctamente"
                    }, { root: true })
                    commit('nuevaCuentaDialogoIsSaving', false)
                    resolve(response.data)
                })
                .catch((error) => {
                    let message = 'Ha habido error al guardar la cuenta'
                    if (error.response.data.message)
                        message = error.response.data.message
                    reject('Error')
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'error',
                        message: message
                    }, { root: true })
                    commit('nuevaCuentaDialogoIsSaving', false)
                }).finally(() => {
                    dispatch('getCuentasTableData')
                })
        })
    },
    async editarCuenta({ getters, state, dispatch, commit }) {
        return new Promise((resolve, reject) => {
            commit('editarCuentaDialogoIsSaving', true)
            const { tipoComercial } = state.editarCuentaDialogo.form
            axios.put(getters.getEndpointFromPath(state.paths.cuentasPath) + state.editarCuentaDialogo.form.id + '/',
                objectCamelToSnakeCase({ ...deleteKeyNullValues(state.editarCuentaDialogo.form), tipoComercial }))
                .then((response) => {
                    dispatch('util/showStatusSnackBar', {
                        statusType: "success",
                        message: "Cuenta guardada correctamente"
                    }, { root: true })
                    dispatch('getCuentasTableData')
                    resolve(response.data)
                    commit('editarCuentaDialogoIsSaving', false)
                })
                .catch((error) => {
                    let message = 'Ha habido error al guardar la cuenta'
                    if (error.response.data.detail)
                        message = error.response.data.detail
                    reject('Error')
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'error',
                        message: message
                    }, { root: true })
                    commit('editarCuentaDialogoIsSaving', false)
                })
        })
    },
    async borrarCuenta({ getters, state, dispatch }, cuenta) {
        axios.delete(getters.getEndpointFromPath(state.paths.cuentasPath) + cuenta.id)
            .then(() => {
                dispatch('util/showStatusSnackBar', {
                    statusType: "success",
                    message: `Cuenta de ${cuenta.nombre} borrada correctamente`
                }, { root: true })
                dispatch('getCuentasTableData')
            })
        // async borrarCuenta({getters, state, dispatch}, cuenta) {
        //     axios.delete(getters.getEndpointFromPath(state.paths.cuentasPath) + cuenta.id)
        //     .then
        // })
    },
    async updateCuentasTableParams({ commit, state }, params) {
        let newParams = { ...state.cuentasTable.params, ...params }
        newParams = removeEmpty(newParams) // eliminate nulls
        commit('cuentasTableParams', newParams)
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}